import React, {useState} from "react";
import "./FormAtelier.scss";
import {getIdWithToken} from "../../../utils/storage/Token";
import {CallbackErrorModalFL, CallbackFinishedModalFL} from "../../Dashboard/Form/ModalForm";
import {
    DeclarationResumeInterface,
    DeclarationURSSAFChangeStateInterface
} from "../../../service/Business/Interfaces/DeclarationInterface";
import StatusDeclaration, {TypeStatusDeclaration} from "../../../utils/Business/StatusDeclaration";
import {UpdateChangeStatusDeclarationURSSAF} from "../../../service/Business/DeclarationService";
import {useToast} from "../../FCObjets/FCToast/FCToast";
import formatEuro from "../../../utils/formatEuro";

type FormDeclarationURSSAFProps = {
    onFinished: CallbackFinishedModalFL;
    onError: CallbackErrorModalFL;
    decURSSAF: DeclarationResumeInterface;
};

const FormDeclarationURSSAF: React.FunctionComponent<FormDeclarationURSSAFProps> = (props) => {
    const toast = useToast();
    const [inputState, setInputState] = useState<TypeStatusDeclaration>(props.decURSSAF.state);

    const handleSubmit = () => {
        const dec: DeclarationURSSAFChangeStateInterface = {
            idDeclaration: props.decURSSAF.idDeclaration,
            state: inputState,
            numDeclaration: props.decURSSAF.num_declaration,
            year: props.decURSSAF.year
        };

        UpdateChangeStatusDeclarationURSSAF(getIdWithToken(), dec).then(() => {
            toast.success("Statut URSSAF mis à jour.", "Déclaration URSSAF");
            props.onFinished();
        }).catch((err) => props.onError(err));
    }

    const echeanceDate = new Date(props.decURSSAF.date);

    return (
        <form className="fcaForm" onSubmit={(e) => e.preventDefault()}>
            {/* Carte récap */}
            <div className="fcaSummaryCard">
                <div className="fcaSummaryHeader">
                    <span className="material-symbols-outlined">account_balance</span>
                    <div>
                        <div className="fcaSummaryTitle">{props.decURSSAF.desc} {props.decURSSAF.year}</div>
                        <div className="fcaSummarySubtitle">
                            Échéance le {echeanceDate.toLocaleDateString("fr-FR", {day: "2-digit", month: "long", year: "numeric"})}
                        </div>
                    </div>
                </div>
                <div className="fcaSummaryGrid">
                    <div className="fcaSummaryItem">
                        <span className="fcaSummaryItemLabel">Chiffre d'affaires</span>
                        <span className="fcaSummaryItemValue">{formatEuro(props.decURSSAF.ca)}</span>
                    </div>
                    <div className="fcaSummaryItem">
                        <span className="fcaSummaryItemLabel">Total URSSAF</span>
                        <span className="fcaSummaryItemValueGold">{formatEuro(props.decURSSAF.total_urssaf)}</span>
                    </div>
                </div>
            </div>

            {/* Sélecteur de statut */}
            <div className="fcaSection">
                <div className="fcaSectionLabel">Statut de la déclaration</div>
                <div className="fcaStatusToggle" role="radiogroup" aria-label="Statut de la déclaration">
                    {StatusDeclaration.ListStatus.map((s) => {
                        const isActive = inputState === s;
                        return (
                            <button
                                key={s}
                                type="button"
                                role="radio"
                                aria-checked={isActive}
                                className={`fcaStatusOption ${isActive ? "active" : ""} ${s === TypeStatusDeclaration.DONE ? "done" : "open"}`}
                                onClick={() => setInputState(s)}
                            >
                                <span className="material-symbols-outlined">
                                    {s === TypeStatusDeclaration.DONE ? "task_alt" : "schedule"}
                                </span>
                                <span className="fcaStatusOptionLabel">{StatusDeclaration.toString(s)}</span>
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="fcaActions">
                <button type="button" className="fcaBtn fcaBtnSecondary" onClick={() => props.onFinished()}>
                    Annuler
                </button>
                <button type="button" className="fcaBtn fcaBtnPrimary" onClick={handleSubmit}>
                    <span className="material-symbols-outlined">check</span>
                    Valider
                </button>
            </div>
        </form>
    );
}

export default FormDeclarationURSSAF;
